var _polygon, _polygon2, _polygon3, _path, _path2, _path3, _path4, _polygon4, _path5, _path6, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "376.42 313.24 404.27 374.02 386.75 378.96 366.09 353.24 376.42 313.24",
    style: {
      fill: "#5BD3C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-2--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "321.03 296.31 284.76 313.02 304.1 391.49 297.94 424.5 366.75 424.5 359.94 388.63 376.64 313.24 338.61 297.63 321.03 296.31",
    style: {
      fill: "#5BD3C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-3--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "284.76 313.02 256.19 374.89 274.43 378.74 295.09 353.02 284.76 313.02",
    style: {
      fill: "#5BD3C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-4--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M275.74,369.51l36.05,41.11-7,7.91-45.43-36.18s-6.23-3-2.49-9.1",
    style: {
      fill: "#5BD3C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-5--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M383.68,370.83l-12,40.83,8.68,6.06,19.61-31.52s8.06-9.1,3-14.22",
    style: {
      fill: "#5BD3C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "freepik--clip-path-6--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M342.92,232s-20.08,18.54-25.68,32.05-.58,27.62,2.51,31.68,5,4.63,5,4.63-10.62,4.06-17.57-6.56-5.22-22.6-3.09-30.9,1.54-32.64,6.37-40.75,11.78-14.1,23.37-12.75,17.76,7.34,21.43,14.87,1.93,20.28,3.09,25.88,6.18,22.4,7.34,32.44S353.16,299.78,351,300.75a12.85,12.85,0,0,1-4.63,1s4.63-23.17,5.6-36.5S353,244,353,244,343.89,232.58,342.92,232Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M124.15,435.32s52.15,27.11,111.75-1.47,79-84,109.88-125.58c16.2-21.79,42.7-33.93,62.92-52.25C473.34,197.43,450,99.48,390.88,72.6,339.67,49.33,280.52,57.67,207.23,97.06S81.13,161.88,42.65,240.38,59.31,397.33,124.15,435.32Z",
    style: {
      fill: "#5BD3C7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.15,435.32s52.15,27.11,111.75-1.47,79-84,109.88-125.58c16.2-21.79,42.7-33.93,62.92-52.25C473.34,197.43,450,99.48,390.88,72.6,339.67,49.33,280.52,57.67,207.23,97.06S81.13,161.88,42.65,240.38,59.31,397.33,124.15,435.32Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-2"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 36.66,
    y1: 368.26,
    x2: 439.71,
    y2: 368.26,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.66,
    y1: 291.95,
    x2: 439.71,
    y2: 291.95,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.66,
    y1: 215.64,
    x2: 439.71,
    y2: 215.64,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 36.66,
    y1: 139.33,
    x2: 439.71,
    y2: 139.33,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 128.3,
    y1: 96,
    x2: 128.3,
    y2: 368.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 370.56,
    y1: 96,
    x2: 370.56,
    y2: 368.44,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 137.3,
    y1: 196.99,
    x2: 134.3,
    y2: 200.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 188.39,
    y1: 143.11,
    x2: 140.91,
    y2: 193.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 191.35,
    y1: 151.26,
    x2: 164.68,
    y2: 178.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 380.93,
    y1: 196.99,
    x2: 377.93,
    y2: 200.15,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 432.01,
    y1: 143.11,
    x2: 384.54,
    y2: 193.18,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 434.98,
    y1: 151.26,
    x2: 408.31,
    y2: 178.67,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.62,
    y1: 351.09,
    x2: 27.62,
    y2: 354.25,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 81.7,
    y1: 297.2,
    x2: 34.23,
    y2: 347.28,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 84.67,
    y1: 305.35,
    x2: 57.99,
    y2: 332.77,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 69.88,
    y1: 131.8,
    x2: 66.89,
    y2: 134.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 120.97,
    y1: 77.91,
    x2: 73.5,
    y2: 127.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 123.93,
    y1: 86.06,
    x2: 97.26,
    y2: 113.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 291.88,
    y1: 131.8,
    x2: 288.89,
    y2: 134.96,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 342.97,
    y1: 77.91,
    x2: 295.5,
    y2: 127.98,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 345.93,
    y1: 86.06,
    x2: 319.26,
    y2: 113.47,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 223.24,
    y1: 276.26,
    x2: 220.24,
    y2: 279.42,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 274.32,
    y1: 222.38,
    x2: 226.85,
    y2: 272.45,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 277.29,
    y1: 230.53,
    x2: 250.62,
    y2: 257.94,
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plants--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M427.92,424.65s-24.76-52.76-19.38-54.28,16.66,6.88,16.66,6.88-33.1-88.7-24.53-95.58S425.24,310,425.24,310,408.15,255.67,410.16,235s23.72-.76,23.72-.76-17.39-74.17-1.24-78,15.61,84.87,15.61,84.87,5.3-63.47,11.77-45.88-7.13,76.46-7.13,76.46,8.87-19.88,13.8-1.53-9.8,92.52-9.8,92.52,12.52-12.23,13.69,3.06-25.92,62.7-25.92,62.7L429.33,430Z",
    style: {
      fill: "#5BD3C7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M427.92,424.65s-24.76-52.76-19.38-54.28,16.66,6.88,16.66,6.88-33.1-88.7-24.53-95.58S425.24,310,425.24,310,408.15,255.67,410.16,235s23.72-.76,23.72-.76-17.39-74.17-1.24-78,15.61,84.87,15.61,84.87,5.3-63.47,11.77-45.88-7.13,76.46-7.13,76.46,8.87-19.88,13.8-1.53-9.8,92.52-9.8,92.52,12.52-12.23,13.69,3.06-25.92,62.7-25.92,62.7L429.33,430Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M433.21,427s-20.64-36.7-16.82-43.59,15.29,9.18,15.29,9.18-26-65-22.17-71.11,16.06,20.65,16.06,20.65-4.59-89.46,3.05-86.41S437,301.55,437,301.55s-4.58-101.69,2.3-98.63,6.12,116.22,6.12,116.22,13.76-43.59,16.05-23.71-17.58,73.41-17.58,73.41S463,326.78,465.33,349,450,412.42,450,412.42s6.88-16.82,6.88-7.65-5.35,20.65-5.35,20.65",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "376.42 313.24 404.27 374.02 386.75 378.96 366.09 353.24 376.42 313.24",
    style: {
      fill: "#5BD3C7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "371.39 332.7 370.21 337.29 393.34 377.1 396.66 376.17 371.39 332.7"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "386.88 378.93 390.22 377.99 368.7 343.12 367.55 347.59 386.88 378.93"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "374.25 321.63 373.03 326.37 399.59 375.34 402.87 374.41 374.25 321.63"
  })))), /*#__PURE__*/React.createElement("polygon", {
    points: "376.42 313.24 404.27 374.02 386.75 378.96 366.09 353.24 376.42 313.24",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.03 296.31 284.76 313.02 304.1 391.49 297.94 424.5 366.75 424.5 359.94 388.63 376.64 313.24 338.61 297.63 321.03 296.31",
    style: {
      fill: "#5BD3C7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-2--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M321.36,424.5l1.39-31.26a2.2,2.2,0,0,0,0-.44l-14.25-90.71-4.2,1.93,14,89.25-1.39,31.23Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M329.7,385.76s0-.08,0-.12L318.4,297.52l-4.23,2,11.1,86.67,2.86,38.36h4.46Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M308.78,424.5l4-30.51a2.22,2.22,0,0,0,0-.68l-15.25-86.15-4.17,1.92,15,84.67-4,30.75Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M375.06,312.59l-4.19-1.72-15.29,79.07a2.27,2.27,0,0,0,0,.78l5.5,33.78h4.51L360,390.4l.13-.65-.22-1.12,3.35-15.09Z"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "334.98 305.29 330.54 305.42 334.23 424.5 338.67 424.5 334.98 305.29"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M350.57,389.82l14.77-81.22-4.2-1.73-15,82.54a2,2,0,0,0,0,.77L352,424.5h4.51Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M342.5,387.06l11.23-83.23-4.25-1.74-11.42,84.65a2,2,0,0,0,0,.54l4.14,37.22h4.47Z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    points: "321.03 296.31 284.76 313.02 304.1 391.49 297.94 424.5 366.75 424.5 359.94 388.63 376.64 313.24 338.61 297.63 321.03 296.31",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "284.76 313.02 256.19 374.89 274.43 378.74 295.09 353.02 284.76 313.02",
    style: {
      fill: "#5BD3C7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-3--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "292.27 342.1 272.37 378.31 274.43 378.74 279.19 372.81 293.48 346.81 292.27 342.1"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "290.48 335.18 289.18 330.14 266.97 377.17 270.32 377.88 290.48 335.18"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "259.72 375.63 263.07 376.34 287.64 324.17 286.33 319.11 259.72 375.63"
  }))), /*#__PURE__*/React.createElement("polyline", {
    points: "284.01 323.32 294.09 350.37 283.97 334.88",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "284.76 313.02 256.19 374.89 274.43 378.74 295.09 353.02 284.76 313.02",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.74,369.51l36.05,41.11-7,7.91-45.43-36.18s-6.23-3-2.49-9.1",
    style: {
      fill: "#5BD3C7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-4--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "308.01 413.48 311.39 410.59 293.21 389.43 275.74 369.51 271.04 370.44 308.01 413.48"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "300.81 415.38 303.82 417.78 306.65 415.29 267.77 371.09 262.73 372.08 300.81 415.38"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M275.74,369.51l36.05,41.11-7,7.91-45.43-36.18s-6.23-3-2.49-9.1",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,409.07c1-.56,18.39-4.72,18.63-2.59s5.42,4.48,7.78,4.48,4.72-1.89,5.19.94-2.12,3.07-4.24,3.3-9.44-2.12-9.44-2.12-6.84,5.66-9.67,7.07-8,1-9.9-.47S299.88,412.37,306,409.07Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M322.05,406.24s6.6-1.89,8-1.18,2.13,14.86,2.13,14.86-.71,1.41-2.13,0-6.13-12-6.13-12",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.74,406.71s6.84-1.65,8.26.94,4.95,14.15,2.12,14.63-3.77-3.31-3.77-3.31l-4.48-8.25-3.07-.47",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.39,408.83s3.3-1.41,4.95-.23,9.2,13.2,7.78,13.68-4.72.23-5.19-.71-6.6-9-6.6-9",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314,412.84s3.06-2.83,4.71-1.88,8.49,9.9,7.08,10.84-2.36,0-3.77-1.88a16.5,16.5,0,0,0-3.54-3.3l-2.83.94",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.68,370.83l-12,40.83,8.68,6.06,19.61-31.52s8.06-9.1,3-14.22",
    style: {
      fill: "#5BD3C7"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-5--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1
    }
  }, _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "380.63 417.23 380.78 416.98 397.39 371.65 392.75 371.37 376.7 415.19 378.5 416.44 380.63 417.23"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "371.7 411.69 375.47 414.33 390.97 371.39 390.54 371.24 386.39 370.99 371.7 411.69"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M404.34,374.37a5.62,5.62,0,0,0-1.42-2.39l-2.38-.14L388,405.43l11.92-19.18Z"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M383.68,370.83l-12,40.83,8.68,6.06,19.61-31.52s8.06-9.1,3-14.22",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377.72,409.07c-1-.56-18.4-4.72-18.63-2.59s-5.43,4.48-7.78,4.48-4.72-1.89-5.19.94,2.12,3.07,4.24,3.3,9.44-2.12,9.44-2.12,6.84,5.66,9.67,7.07,8,1,9.9-.47S383.85,412.37,377.72,409.07Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.68,406.24s-6.6-1.89-8-1.18-2.12,14.86-2.12,14.86.71,1.41,2.12,0,6.14-12,6.14-12",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,406.71s-6.83-1.65-8.25.94-5,14.15-2.12,14.63,3.77-3.31,3.77-3.31l4.48-8.25,3.07-.47",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.34,408.83s-3.3-1.41-4.95-.23-9.2,13.2-7.78,13.68,4.71.23,5.19-.71,6.6-9,6.6-9",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.7,412.84S366.64,410,365,411s-8.49,9.9-7.07,10.84,2.36,0,3.77-1.88a16.5,16.5,0,0,1,3.54-3.3l2.83.94",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.66,292.13s-5.71,1.76-8.13,5.28.44,30.77.44,30.77l18.25-10.11,19.12,12.09s-1.76-27.91-3.3-31.87-11.21-8.57-14.51-8.13S323.66,292.13,323.66,292.13Z",
    style: {
      fill: "#5BD3C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.03 276.97 321.03 302.25 333.12 334.78 343.45 301.59 343.45 276.75 321.03 276.97",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,286.05a20.23,20.23,0,0,0,11.65,3.67h0a20.2,20.2,0,0,0,10.77-3.1v-9.87L321,277Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M332.68,284h0a20.37,20.37,0,0,1-20.37-20.36L308.72,235a24,24,0,0,1,24-24h0a24,24,0,0,1,24,24L353,263.6A20.36,20.36,0,0,1,332.68,284Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M337.91,255.8s5.19-4.35,11.39.34",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.53,255.3a7.86,7.86,0,0,0-5.19-1.17",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.92,245.42s5.53-2.68,8.88,2.51",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M331,267.36s2.35,1.84,4.36,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.7,271.38s4.86,3,7.7,0",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.92,232s-20.08,18.54-25.68,32.05-.58,27.62,2.51,31.68,5,4.63,5,4.63-10.62,4.06-17.57-6.56-5.22-22.6-3.09-30.9,1.54-32.64,6.37-40.75,11.78-14.1,23.37-12.75,17.76,7.34,21.43,14.87,1.93,20.28,3.09,25.88,6.18,22.4,7.34,32.44S353.16,299.78,351,300.75a12.85,12.85,0,0,1-4.63,1s4.63-23.17,5.6-36.5S353,244,353,244,343.89,232.58,342.92,232Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#freepik--clip-path-6--inject-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M340.57,219s-2.37,6.53-19.42,25.24-21.68,36.56-16.5,54",
    style: {
      fill: "none",
      stroke: "#707070",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M336.36,212.48s-9.38,7.77-21,19.41a108.81,108.81,0,0,0-18.12,24.27",
    style: {
      fill: "none",
      stroke: "#707070",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.77,220.57s7.12,12.94,11,20.71,8.42,51.44-5.17,67",
    style: {
      fill: "none",
      stroke: "#707070",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 339.92,
    y1: 209.89,
    x2: 342.92,
    y2: 232,
    style: {
      fill: "none",
      stroke: "#707070",
      strokeMiterlimit: 10
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M342.92,232s-20.08,18.54-25.68,32.05-.58,27.62,2.51,31.68,5,4.63,5,4.63-10.62,4.06-17.57-6.56-5.22-22.6-3.09-30.9,1.54-32.64,6.37-40.75,11.78-14.1,23.37-12.75,17.76,7.34,21.43,14.87,1.93,20.28,3.09,25.88,6.18,22.4,7.34,32.44S353.16,299.78,351,300.75a12.85,12.85,0,0,1-4.63,1s4.63-23.17,5.6-36.5S353,244,353,244,343.89,232.58,342.92,232Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.82,
    y: 244.94,
    width: 8.88,
    height: 17.77,
    rx: 2.96,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.09,
    y: 244.94,
    width: 8.88,
    height: 17.77,
    rx: 2.96,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.3,244.94v-9.66a28.19,28.19,0,0,0-28.19-28.19h0a28.2,28.2,0,0,0-28.2,28.19v9.66",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M359.53,262.62s-1.25,9.67-13.08,13.61",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,275.81c.5,1.45-.91,3.25-3.16,4s-4.46.24-5-1.21.91-3.25,3.15-4S345.53,274.36,346,275.81Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "143.6 288.28 102.28 307.97 114.2 424.74 196.57 424.74 208.22 306.03 169.39 288 143.6 288.28",
    style: {
      fill: "#5BD3C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 160.16,
    cy: 322.51,
    r: 1.4,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.56,330.91a1.4,1.4,0,1,1-1.4-1.4A1.4,1.4,0,0,1,161.56,330.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "174.49 294.24 163.2 306.83 158.38 319.06 153.19 306.65 142.27 294.24 142.27 272.2 174.49 272.2 174.49 294.24",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.27,282a22.62,22.62,0,0,0,17.5,8.25h0a22.56,22.56,0,0,0,14.72-5.44V272.2H142.27Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137.08,
    y: 210.52,
    width: 45.38,
    height: 73.53,
    rx: 20.42,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.12,243.12l-.67,16.07a3.4,3.4,0,0,1-2.29,3.15c-1.21.37-2.59,0-3.34-2.73",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151,265.53h18s-3.15,6.86-9.26,6.86S151,265.53,151,265.53Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.28,267.94h15.16a14.77,14.77,0,0,0,1.5-2.41H151A13.11,13.11,0,0,0,152.28,267.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 150.79,
    cy: 247.29,
    rx: 1.3,
    ry: 3.06,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 170.23,
    cy: 247.29,
    rx: 1.3,
    ry: 3.06,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.16,239.23s4.44-2.78,9.45,1.67",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.77,210.52h0a22.69,22.69,0,0,0-22.69,22.69v20.67l.19,0h1.85v-8.52s9.26,0,20.19-5.92S173,223.86,173,223.86s2.41,11.67,5,13.89l2.6,2.22v14.08h1.85V233.21A22.69,22.69,0,0,0,159.77,210.52Z",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.83,242.94h4.25a0,0,0,0,1,0,0v16.85a0,0,0,0,1,0,0h-4.25a4.08,4.08,0,0,1-4.08-4.08V247A4.08,4.08,0,0,1,132.83,242.94Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.26,242.94h4.25a0,0,0,0,1,0,0v16.85a0,0,0,0,1,0,0h-4.25a4.08,4.08,0,0,1-4.08-4.08V247A4.08,4.08,0,0,1,186.26,242.94Z",
    transform: "translate(372.7 502.73) rotate(180)",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.38,242.94V232.19a26.3,26.3,0,0,1,26.3-26.3h0a26.31,26.31,0,0,1,26.3,26.3v10.75",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,259.79s-1.3,10-13.52,14.08",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172,273.43c.52,1.5-.94,3.36-3.26,4.17s-4.62.24-5.14-1.26.94-3.36,3.26-4.17S171.51,271.93,172,273.43Z",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.28 307.97 67.33 381.92 81.75 394.5 107.82 361.78 102.28 307.97",
    style: {
      fill: "#5BD3C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "99.41 330.64 107.9 359.28 97.82 342.83",
    style: {
      fill: "none",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.22 306.03 241.5 380.36 220.98 389.24 202.67 359.84 208.22 306.03",
    style: {
      fill: "#5BD3C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "86.19 380.08 116.14 408.09 107.82 417.8 64.28 390.79 69.28 377.48",
    style: {
      fill: "#5BD3C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.15,406.43c1.22-.66,21.63-5.55,21.91-3.05s6.38,5.27,9.15,5.27,5.55-2.22,6.1,1.11-2.49,3.6-5,3.88-11.09-2.5-11.09-2.5-8,6.66-11.37,8.33-9.43,1.1-11.65-.56S103.94,410.31,111.15,406.43Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130,403.1s7.77-2.22,9.43-1.38,2.5,17.47,2.5,17.47-.84,1.66-2.5,0S132.23,405,132.23,405",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.13,403.66s8-1.94,9.7,1.11,5.83,16.64,2.5,17.19-4.44-3.88-4.44-3.88l-5.27-9.71-3.6-.55",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.35,406.15s3.89-1.66,5.83-.27S140,421.41,138.33,422s-5.55.28-6.1-.83-7.77-10.54-7.77-10.54",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.58,410.87s3.61-3.33,5.55-2.22,10,11.65,8.32,12.76-2.78,0-4.44-2.22a19.43,19.43,0,0,0-4.16-3.89l-3.33,1.11",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "215.95 373 198.39 410.06 209.69 416.03 242.9 380.84 233.37 370.29",
    style: {
      fill: "#5BD3C7",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.18,406.43c-1.22-.66-21.64-5.55-21.91-3.05s-6.38,5.27-9.16,5.27-5.54-2.22-6.1,1.11,2.5,3.6,5,3.88,11.09-2.5,11.09-2.5,8,6.66,11.37,8.33,9.43,1.1,11.65-.56S214.39,410.31,207.18,406.43Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.32,403.1s-7.77-2.22-9.43-1.38-2.5,17.47-2.5,17.47.83,1.66,2.5,0S186.1,405,186.1,405",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.2,403.66s-8-1.94-9.71,1.11S176.67,421.41,180,422s4.43-3.88,4.43-3.88l5.27-9.71,3.61-.55",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,406.15s-3.88-1.66-5.82-.27S178.33,421.41,180,422s5.54.28,6.1-.83,7.76-10.54,7.76-10.54",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.75,410.87s-3.61-3.33-5.55-2.22-10,11.65-8.32,12.76,2.77,0,4.44-2.22a19.43,19.43,0,0,1,4.16-3.89l3.33,1.11",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--text-balloon--inject-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M259.66,168.21h-65a11.37,11.37,0,0,0-11.37,11.36v19A11.37,11.37,0,0,0,194.64,210h8l-10.91,14.27L216.26,210h43.4A11.37,11.37,0,0,0,271,198.6v-19A11.37,11.37,0,0,0,259.66,168.21Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeMiterlimit: 10
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.23,190.41a2.65,2.65,0,1,1-2.65-2.64A2.65,2.65,0,0,1,218.23,190.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.79,190.41a2.65,2.65,0,1,1-2.64-2.64A2.64,2.64,0,0,1,229.79,190.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.35,190.41a2.64,2.64,0,1,1-2.64-2.64A2.64,2.64,0,0,1,241.35,190.41Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-2--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 271.31,
    y: 421.73,
    width: 121.14,
    height: 4.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.47,
    y: 421.73,
    width: 105.59,
    height: 4.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413.11 413.04 312.09 413.04 322.98 335.91 424 335.91 413.11 413.04",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "417.29 413.04 316.27 413.04 327.16 335.91 428.18 335.91 417.29 413.04",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.33,377.19l10.14,49.42H370.4l-10.13-49.42Zm-17.68,14.67a.92.92,0,0,0,.9.7l14.77-.14a.92.92,0,0,0,.88-1.14l-1.33-5.54a.93.93,0,0,0-.9-.71l-14.77.14a.93.93,0,0,0-.89,1.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--device-1--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 92.13,
    y: 421.73,
    width: 121.14,
    height: 4.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.29,
    y: 421.73,
    width: 105.59,
    height: 4.89,
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "233.93 413.04 132.91 413.04 143.8 335.91 244.82 335.91 233.93 413.04",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.11 413.04 137.09 413.04 147.98 335.91 249 335.91 238.11 413.04",
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.16,377.19l10.13,49.42H191.22l-10.13-49.42Zm-17.69,14.67a.93.93,0,0,0,.9.7l14.77-.14a.93.93,0,0,0,.89-1.14l-1.34-5.54a.92.92,0,0,0-.9-.71l-14.77.14a.92.92,0,0,0-.88,1.14Z",
    style: {
      fill: "#fff",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Table--inject-2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.83,
    y: 426.61,
    width: 430.92,
    height: 4.84,
    style: {
      fill: "#263238",
      stroke: "#263238",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.14c4b7792a07400801a7422107ea077a.svg";
export { ForwardRef as ReactComponent };